import { Injectable } from "@angular/core";
import { Store } from "@ngxs/store";
import { ConfigState } from "src/store/config/config.state";
import { AppState } from "src/store/app/app.state";
import { environment } from "src/environments/environment";
import {
    Configuration,
    DefaultApi,
    DefaultApiInterface,
    MobileAppApi,
    MobileAppApiInterface,
} from "@apacta/sdk";
import { LocalStorageService } from "src/app/services/local-storage.service";

@Injectable({
    providedIn: "root",
})
export class ApactaApiSdkService {
    private static readonly USER_API_KEY = "USERAPIKEY";
    private sdkConfiguration: Configuration = null;

    constructor(
        private store: Store,
        private localStorageService: LocalStorageService
    ) {}

    public configuration(): DefaultApiInterface {
        if (this.sdkConfiguration === null) {
            this.sdkConfiguration = this.getConfiguration();
        }

        return new DefaultApi(this.sdkConfiguration);
    }

    public mobileConfiguration(): MobileAppApiInterface {
        if (this.sdkConfiguration === null) {
            this.sdkConfiguration = this.getConfiguration();
        }

        return new MobileAppApi(this.sdkConfiguration);
    }

    public resetConfiguration(): void {
        this.sdkConfiguration = null;
    }

    private getConfiguration(): Configuration {
        const config = this.store.selectSnapshot(ConfigState.getConfig);
        const apiKey = this.getApiKey();

        return new Configuration({
            apiKey,
            basePath: environment.appUrl,
            headers: {
                Accept: "application/json",
                "X-Apacta-App-Version": config ? config.osVersion.toString() : "",
                "X-Apacta-App-Build": config ? config.osVersion.toString() : "",
                "X-Apacta-App-Details": config ? config.model : "",
            },
        });
    }

    private getApiKey(): string {
        const storedKey = this.localStorageService.read(ApactaApiSdkService.USER_API_KEY);

        if (storedKey !== "" && storedKey !== null) {
            return storedKey;
        }

        return this.store.selectSnapshot(AppState.getUserApiKey);
    }
}
